import { FilterAttribute, FilterOperator } from './enums';

export class DrFilter {
    attribute: FilterAttribute;
    operator?: FilterOperator;
    value?: any;

    constructor(value?: Partial<DrFilter>) {
        if (value) {
            Object.assign(this, value);
        }
    }
}
